<template>
     <tr>
        <div class="responsiveTD dynamic3ColExpand" @click="toggleCollapse">
            <td data-label="Well ID">
                {{wellId}}
            </td>
            <td data-label="Operator">
                <router-link :to="{name: 'Operators', params: {operator: operShort}}" class="link">{{operator}}</router-link>
            </td>
            <td data-label="Work Begin Date">
                {{beginDate}}
            </td>
            <button data-label="More Information" v-show="expandable" style="cursor: pointer;">
                <svg v-if="!isCollapsed" width="24" height="24">
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
                </svg>
                <svg v-else width="24" height="24">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                </svg>
            </button>
        </div>
        <td class="expandableTableRow" v-show="expandable" :style="currHeight" style="padding: 0;">
            <div class="expandableTableContent">
                <div class="category modifyPermitInfo" v-if="general.length > 0">
                    <div v-for="obj in general" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import { readFromObj, formatDateLT } from '../../helpers/Formatting.js';

export default {
    name: 'lease-modify-permit-item',
    props: [
        "modifyPermitItem"
    ],
    data: () => ({
        wellId: null,
        operator: null,
        operShort: "",
        beginDate: null,
        general: [],
        expandable: false,
        isCollapsed: true,
        expandableHeight: 0,
    }),
    created() {
        var globv = this;
        globv.wellId = globv.modifyPermitItem['well']['id'];
        globv.operator = globv.modifyPermitItem['operator'];
        globv.operShort = globv.modifyPermitItem['operShort'];
        globv.beginDate = formatDateLT(globv.modifyPermitItem['workBeginDate']);

        let expectedVariables = [
            {
                varName: "well.name",
                fieldName: "Well Name"
            },
            {
                varName: "well.type",
                fieldName: "Well Type"
            },
            {
                varName: "status",
                fieldName: "Status"
            },
            {
                varName: "statusDate",
                fieldName: "Status Date",
                format: formatDateLT
            },
            {
                varName: "surfaceBlock",
                fieldName: "Surface Block"
            },
            {
                varName: "bottomBlock",
                fieldName: "Bottom Block"
            },
            {
                varName: "coordinates",
                fieldName: "Latitude / Longitude",
                format: function(coord) {
                    if (coord && coord.length === 2) {
                        let lat = coord[1];
                        let lon = coord[0];
                        if (lat !== null && lon !== null) {
                            return lat + "° / " + lon + "°";
                        }
                    }

                    return null;
                }
            },
            {
                varName: "protraction",
                fieldName: "Protraction"
            },
            {
                varName: "description",
                fieldName: "Description"
            }
        ]

        globv.general = readFromObj(globv.modifyPermitItem, expectedVariables);
        
        globv.expandable = globv.general.length > 0;
        globv.expandableHeight = (globv.general.length) * 24;
    },
    methods: {
        toggleCollapse: function() {
            var globv = this;
            if (globv.expandable)
                globv.isCollapsed = !globv.isCollapsed;
        }
    },
    computed: {
        currHeight() {
            var globv = this;

            if (globv.expandable) {
                return {
                    "max-height": globv.isCollapsed ? "0px" : globv.expandableHeight * 5 + 'px'
                }
            }
            
            return {};
        }
    }
}
</script>